/* eslint react/prop-types: off */
import React, { Fragment } from 'react'
import _ from 'lodash'
import Select from 'react-select'
import CreatableSelect from 'react-select/lib/Creatable'
import {
  Col,
  ContentSectionBlock,
  DetailList,
  FormInputText,
  Row,
  FormInput,
  FormInputCheckbox,
  Tip
} from 'camino-react'

import { cloudhelpGet, cloudhelpPatch } from 'Utilities/CloudHelp'
import { csrfToken } from 'Utilities/Csrf'
import StringManipulator from 'Utilities/StringManipulator'

import Alert from 'Components/Alert'
import BooleanPill from 'Components/BooleanPill'
import ErrorList from 'Components/ErrorList'
import Modal from 'Components/Modal'
import ServiceCategories from 'Components/Tickets/Form/Sections/Services/ServiceCategories'
import UserCreateForm from 'Components/Users/Create/Form'

import ClientDetails from "./ClientDetails";
import ClientFormFields from "./ClientFormFields";

export default class TicketDetailsClientInformation extends React.Component {
  constructor (props) {
    super(props)

    const { ticket } = props

    this.state = {
      ticket,
      showEditModal: false,
      primary_contact_email: ticket.primary_contact_email,
      contact_number: ticket.contact_number || (ticket.primary_contact_numbers.length ? ticket.primary_contact_numbers[0].number : null),
      secondary_contact_email: ticket.secondary_contact_email,
      client_name: ticket.client_name,
      client_contact_name: ticket.contact_name,
      client_id: ticket.client_id || '',
      client_contact_id: ticket.client_contact_id,
      client_contact_path: ticket.client_contact_path,
      clients: [],
      client_contacts: [],
      clientContactAuthorised: ticket.client_contact_authorised,
      clientIsManaged: ticket.client_is_managed,
      users: [],
      showSecondaryContactField: !!ticket.secondary_contact_email,
      errors: [],
      ticket_type_id: ticket.ticket_type_id,
      submitButtonText: 'Update',
      submitButtonClasses: 'button',
      clientContactLoading: false,
      creatingContact: false,
      loadingClients: false,
      service_category_id: ticket.service_category_id,
      sub_category_id: ticket.sub_category_id,
      customer_contract_id: ticket.customer_contract_id,
      service_id: ticket.service_id,
      service_type: ticket.service_type,
      secondaryContactEmail: { label: ticket.secondary_contact_email, value: ticket.secondary_contact_email },
      disabledContactNotifications: ticket.disabledContactNotifications
    }
  }

  handleSelectChange = (fieldName, selectedOption) => {
    const option = selectedOption || {}

    this.setState({ [fieldName]: option.value })
  }

  showEditModal (event) {
    event.preventDefault()

    this.setState({
      showEditModal: true
    })
  }

  setFieldErrorClasses (field) {
    const { fieldsWithErrors } = this.state

    if (_.includes(fieldsWithErrors, field)) {
      return ('error')
    }
  }

  handleInputChange (event) {
    const target = event.target
    const value = target.type === 'checkbox' ? target.checked : target.value
    const name = target.name
    this.setState({
      [name]: value
    })
  }

  submitForm (e) {
    e.preventDefault()

    const {
      primary_contact_name,
      primary_contact_email,
      contact_number,
      secondary_contact_email,
      client_name,
      client_id,
      client_contact_id,
      customer_contract_id,
      service_id,
      service_type,
      service_category_id,
      sub_category_id,
      ticket_type_id,
      ticket,
      disabledContactNotifications
    } = this.state

    const {
      updateTicket,
      updateAlert,
      collectHistory,
      assignCurrentUser
    } = this.props

    const patchData = {
      authenticity_token: csrfToken(),
      ticket: {
        primary_contact_name,
        primary_contact_email,
        ticket_type_id,
        contact_number,
        secondary_contact_email,
        client_name,
        customer_contract_id,
        service_category_id,
        sub_category_id,
        service_id,
        service_type,
        client_id,
        client_contact_id,
        disabled_contact_notifications: disabledContactNotifications
      },
      assignCurrentUser
    }

    this.setState({
      submitButtonText: 'Updating...',
      submitButtonClasses: 'button button--disabled'
    })

    cloudhelpPatch(`/tickets/${ticket.id}`, patchData)
      .then((response) => {
        this.setState({
          showEditModal: false,
          ticket: response.data.ticket,
          contact_number: response.data.contact_number,
          submitButtonText: 'Update',
          submitButtonClasses: 'button'
        })

        updateAlert(true, 'success', 'Ticket has been successfully updated')
        updateTicket(response.data.ticket)
        collectHistory()
      })
      .catch((error) => {
        const errorObject = error.response.data.errors[0]
        const errorText = error.response.status == 422 ? _.map(errorObject, (error, field) => (this.toErrorMessage(StringManipulator.humanize(field), error))) : 'There was an issue assigning this problem.'

        this.setState({
          errors: errorText,
          fieldsWithErrors: Object.keys(errorObject),
          submitButtonText: 'Update',
          submitButtonClasses: 'button'
        })
      })
  }

  toErrorMessage (field, error) {
    let fieldName = _.capitalize(field)
    fieldName = _.replace(fieldName, /_id/, '')
    fieldName = _.replace(fieldName, /_/, ' ')

    return `${fieldName} ${error}`
  }

  setFieldErrorClasses = (field) => {
    if (_.includes(this.state.fieldsWithErrors, field)) {
      return ('error')
    }
  }

  hasRole = (...args) => {
    const { roles } = this.props

    return _.get(roles, args)
  }

  isChangingCategories = () => {
    const fields = ['client_id', 'service_category_id', 'sub_category_id', 'customer_contract_id', 'service_id']

    return _.some(fields, field => (
      this.props.ticket[field] !== this.state[field] || _.isNil(this.state[field])
    ))
  }

  render () {
    const { current_user, clientPath, ticket_types } = this.props
    const {
      secondary_contact_email,
      preferredContactMethod,
      primary_contact_numbers,
      lifecycleStatus,
      twentyHourSupport,
      client_id: originalClientId
    } = this.props.ticket

    const { setFieldErrorClasses, handleSelectChange } = this

    const {
      ticket,
      showEditModal,
      clientContactAuthorised,
      clientIsManaged,
      contact_number,
      client_contact,
      client_contact_path,
      client_contact_name,
      service_category_id,
      sub_category_id,
      customer_contract_id,
      service_id,
      service_type,
      ticket_type_id,
      submitButtonText,
      submitButtonClasses,
      client_name,
      primary_contact_email,
      client_id,
      client_contact_id,
      client,
      creatingContact,
      clientContactLoading,
      loadingClients,
      clientsUsersEmailsOptions,
      secondaryContactEmail,
      disabledContactNotifications
    } = this.state

    const addContactButtonStyles = {
      display: 'flex',
      border: '1px solid #c0e2ff',
      borderTopRightRadius: '5px',
      borderBottomRightRadius: '5px',
      height: '36px',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '18px',
      cursor: 'pointer'
    }

    const allowedContactMethods = client_contact && _({ Phone: client_contact.allow_phone, Email: client_contact.allow_email }).pickBy(v => v).keys().join(' or ')
    const contactMethod = preferredContactMethod || allowedContactMethods
    const phoneNumber = (phoneNumbers) => {
      if (_.isEmpty(phoneNumbers)) {
        return 'Not provided'
      }

      return _.map(phoneNumbers, phone => (
        <p>
          {`${_.capitalize(phone.phone_type.replace('telephone', '').replace('_', ''))} ${phone.number}`}
        </p>
      ))
    }

    const contentSectionActions = []
    if (this.hasRole('ticket', 'update') && _.isNull(ticket.primary_ticket_id)) {
      contentSectionActions.push({ text: 'edit', onClick: event => this.showEditModal(event) })
    }

    const filteredTicketTypes = _.filter(ticket_types, type => (_.isNil(type.ownerable_id) || type.name === 'User Management'))
    const ticketTypeOptions = _.map(filteredTicketTypes, type => ({ value: type.id, label: type.name, key: type.id }))

    return (
      <Fragment>
        <ContentSectionBlock title="Company information" actions={contentSectionActions}>
          <ClientDetails {...{ ticket, current_user, clientPath }} />

          {current_user.calligo_employee &&
            (
              <Modal showModal={showEditModal} title="Edit company information" removeModal={(event) => { this.setState({ showEditModal: false }) }}>
                {disabledContactNotifications && (
                  <Alert type="info">
                    No customer notifications will be sent out, as they have been
                    disabled.
                  </Alert>
                )}
                <Fragment>
                  {_.isNull(ticket.assignee_user_id) && current_user.queues && (
                    <Alert showAlert alertType="info" text="This ticket currently has no assignee, by updating it you will be assigned to this ticket" />
                  )}

                  <Alert showAlert={!_.isEmpty(this.state.errors)} alertType="error">
                    <ErrorList errors={this.state.errors} />
                  </Alert>
                  <Alert showAlert={_.isEmpty(contact_number)} alertType="warning">
                    No Contact number was provided
                  </Alert>

                  <form onSubmit={event => (this.submitForm(event))}>
                    <ClientFormFields {...{ 
                      current_user,
                      setParentState: (newState) => this.setState(newState), 
                      ticket,
                      primary_contact_email,
                      contact_number,
                      client_id,
                      client_contact_id,
                      secondaryContactEmail,
                      disabledContactNotifications,
                    }} />

                    {this.isChangingCategories() && (
                      <Fragment>
                        <div>
                          <label htmlFor="ticket_ticket_type">
                            Type
                          </label>
                          <Select
                            id="ticket_ticket_type_id"
                            className={this.setFieldErrorClasses('ticket_type')}
                            name="ticket[ticket_type_id]"
                            value={ticket_type_id}
                            onChange={option => (
                              handleSelectChange('ticket_type_id', option)
                            )}
                            clearable={false}
                            placeholder="-"
                            options={_.orderBy(ticketTypeOptions, 'label')}
                            isLoading={_.isEmpty(ticket_types)}
                          />
                        </div>

                        <ServiceCategories {...{
                          clientId: client_id,
                          service_category_id,
                          sub_category_id,
                          customer_contract_id,
                          service_id,
                          service_type,
                          ticket_type_id: ticket.ticket_type_id,
                          handleSelectChange,
                          setFieldErrorClasses,
                          currentUser: current_user,
                        }} />
                      </Fragment>
                    )}

                    <div className="form-section">
                      <div className="form-section__actions form-section__actions--space-between">
                        <a className="button button--secondary form-section__action" onClick={(event) => { this.setState({ showEditModal: false }) }}>
                          Cancel
                        </a>
                        <button name="commit" value={submitButtonText} className={submitButtonClasses} type="submit">
                          Submit
                        </button>
                      </div>
                    </div>
                  </form>
                </Fragment>
              </Modal>
            )
          }
        </ContentSectionBlock>
        <ContentSectionBlock title="Services">
          <DetailList list={[
            { title: 'Contract', content: ticket.customer_contract_name },
            { title: 'Service', content: ticket.service_name },
            { title: 'Category', content: ticket.service_category_name },
            { title: 'Sub Category', content: ticket.sub_category_name },
          ]} />
        </ContentSectionBlock>
      </Fragment>
    )
  }
}
